var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("排单情况列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            staticClass: "demo-form-inline",
                            attrs: { model: _vm.form, inline: true }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "row"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "_let-item",
                                    staticStyle: { height: "180px" }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "商家"
                                          },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.supply_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "supply_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.supply_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "small",
                                              multiple: "",
                                              placeholder: "选择城市"
                                            },
                                            nativeOn: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.search.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.form.city,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "city", $$v)
                                              },
                                              expression: "form.city"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                value: "",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.citys, function(item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            })
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _vm.resData
                                          ? _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "代采组"
                                                },
                                                model: {
                                                  value: _vm.form.pgid,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pgid",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.pgid"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "全部",
                                                    value: ""
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._l(_vm.pgOption, function(
                                                  item
                                                ) {
                                                  return _c("el-option", {
                                                    key: item.value,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.value
                                                    }
                                                  })
                                                })
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _vm.resData
                                          ? _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  filterable: "",
                                                  placeholder: "代采员"
                                                },
                                                model: {
                                                  value: _vm.form.pg_member_id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pg_member_id",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.pg_member_id"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "全部",
                                                    value: ""
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.memberOption,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.value,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "商品名称"
                                          },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.goods_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "商品货号"
                                          },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.goods_no,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_no",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_no"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "small",
                                              placeholder: "数据展示"
                                            },
                                            model: {
                                              value: _vm.form.data_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "data_type",
                                                  $$v
                                                )
                                              },
                                              expression: "form.data_type"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.dataOption, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.key
                                                }
                                              })
                                            })
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "small",
                                              placeholder: "预计回货天数"
                                            },
                                            model: {
                                              value: _vm.form.return_day,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "return_day",
                                                  $$v
                                                )
                                              },
                                              expression: "form.return_day"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.dayOption, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.key
                                                }
                                              })
                                            })
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "small",
                                              placeholder: "跟进来源"
                                            },
                                            model: {
                                              value: _vm.form.handle_source,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "handle_source",
                                                  $$v
                                                )
                                              },
                                              expression: "form.handle_source"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.source, function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.key
                                                }
                                              })
                                            })
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "small",
                                              placeholder: "商品状态"
                                            },
                                            model: {
                                              value: _vm.form.goods_sale_status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "goods_sale_status",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.goods_sale_status"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.goodsSaleStatus,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "small",
                                              placeholder: "sku状态"
                                            },
                                            model: {
                                              value: _vm.form.sku_status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "sku_status",
                                                  $$v
                                                )
                                              },
                                              expression: "form.sku_status"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.skuStatus, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            })
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: { height: "80px !important" }
                                  },
                                  [
                                    _c("el-form-item", [
                                      _c(
                                        "div",
                                        { staticClass: "special-filter-box" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "_filter-box" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "_filter-box-item"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "_filter-title"
                                                    },
                                                    [_vm._v("单款欠货数量:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100px"
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请输入最小值"
                                                    },
                                                    model: {
                                                      value: _vm.form.min,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "min",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.min"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "line-height": "32px"
                                                      }
                                                    },
                                                    [_vm._v("至")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100px"
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请输入最大值"
                                                    },
                                                    model: {
                                                      value: _vm.form.max,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "max",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.max"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "_filter-box-item"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "_filter-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            待代采数量   :\n                          "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100px"
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请输入最小值"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.plan_num_min,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "plan_num_min",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.plan_num_min"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "line-height": "32px"
                                                      }
                                                    },
                                                    [_vm._v("至")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100px"
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请输入最大值"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.plan_num_max,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "plan_num_max",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.plan_num_max"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "_filter-box-item"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "_filter-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            总数量   :\n                          "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100px"
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请输入最小值"
                                                    },
                                                    model: {
                                                      value: _vm.form.total_min,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "total_min",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.total_min"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "line-height": "32px"
                                                      }
                                                    },
                                                    [_vm._v("至")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100px"
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请输入最大值"
                                                    },
                                                    model: {
                                                      value: _vm.form.total_max,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "total_max",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.total_max"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "40px",
                                                "margin-left": "10px",
                                                width: "70px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: { size: "small" },
                                                  model: {
                                                    value: _vm.form.type,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "type",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.type"
                                                  }
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      value: 1,
                                                      label: "且"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-option", {
                                                    attrs: {
                                                      value: 2,
                                                      label: "或"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "代采计划生成时间：",
                                  "label-width": "140px"
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    size: "small",
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { value: "1", label: "4" },
                                    model: {
                                      value: _vm.form.is_reminder,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_reminder", $$v)
                                      },
                                      expression: "form.is_reminder"
                                    }
                                  },
                                  [_vm._v("\n                  客服有催单")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { value: "1", label: "4" },
                                    model: {
                                      value: _vm.form.is_strength,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_strength", $$v)
                                      },
                                      expression: "form.is_strength"
                                    }
                                  },
                                  [_vm._v("\n                  实力档口")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "平均计划开单时长(天)" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: { placeholder: "开始", size: "small" },
                                  model: {
                                    value: _vm.form.avg_plan_time_min,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "avg_plan_time_min",
                                        $$v
                                      )
                                    },
                                    expression: "form.avg_plan_time_min"
                                  }
                                }),
                                _vm._v(
                                  "\n                至\n                "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: { placeholder: "结束", size: "small" },
                                  model: {
                                    value: _vm.form.avg_plan_time_max,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "avg_plan_time_max",
                                        $$v
                                      )
                                    },
                                    expression: "form.avg_plan_time_max"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "平均订单入库时长(天)" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: { placeholder: "开始", size: "small" },
                                  model: {
                                    value: _vm.form.avg_stocking_time_min,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "avg_stocking_time_min",
                                        $$v
                                      )
                                    },
                                    expression: "form.avg_stocking_time_min"
                                  }
                                }),
                                _vm._v(
                                  "\n                至\n                "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: { placeholder: "结束", size: "small" },
                                  model: {
                                    value: _vm.form.avg_stocking_time_max,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "avg_stocking_time_max",
                                        $$v
                                      )
                                    },
                                    expression: "form.avg_stocking_time_max"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("\n                  查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center",
                  position: "relative"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      right: "0",
                      top: "10px"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.editScheduleDay([], 1)
                          }
                        }
                      },
                      [_vm._v("\n            批量编辑天数")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "success" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("\n            导出")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.tableLoading,
                        expression: "tableLoading"
                      }
                    ],
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.resData.list,
                      "tooltip-effect": "dark",
                      border: "",
                      "cell-class-name": _vm.addBackground
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        fixed: "left",
                        align: "center",
                        width: "55"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_img",
                        label: "图片",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "70px", height: "70px" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: { src: scope.row.imgs[0] },
                                    on: {
                                      click: function($event) {
                                        return _vm.showImages(scope.row.imgs)
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_name",
                        label: "商品名称",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "supply_name",
                        label: "商家",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "supply_city",
                        label: "城市",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pgname",
                        label: "代采组",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pg_member_name",
                        label: "代采员",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_no",
                        label: "商品货号",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_status",
                        label: "商品状态",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "paln_billing_avg",
                        label: "平均计划开单时长(天)",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "order_stockin_avg",
                        label: "平均订单入库时长(天)",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "颜色",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "122"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return scope.row.sku
                                ? _vm._l(scope.row.sku, function(item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "table-div" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.co_val) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "尺码",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "122"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return scope.row.sku
                                ? _vm._l(scope.row.sku, function(item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "table-div" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.si_val) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "SKU状态",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "122"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return scope.row.sku
                                ? _vm._l(scope.row.sku, function(item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "table-div" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.is_sale) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "待代采",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "105"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return scope.row.sku
                                ? _vm._l(scope.row.sku, function(item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "table-div" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.plan_num) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "欠货",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "105"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return scope.row.sku
                                ? _vm._l(scope.row.sku, function(item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "table-div" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.owe_num) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "总数量",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "105"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.sku
                                ? _c("div", { staticClass: "table-div" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.calcuatorSku(scope.row.sku)
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "用户排单",
                        "show-overflow-tooltip": "",
                        align: "center",
                        width: "105"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return scope.row.sku
                                ? _vm._l(scope.row.sku, function(item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "table-div" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.pd_num) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        "cell-style": { "background-color": "yellow" },
                        prop: "estimated_return_day",
                        label: "预计回货天数",
                        align: "center",
                        width: "100"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.is_stop_sale == 1
                                ? _c("span", [_vm._v("档口停售")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.is_stop_sale == 0
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row.estimated_return_day)
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "handle_admin",
                        label: "跟进人",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "handle_source",
                        label: "跟进来源",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "handle_time",
                        label: "跟进时间",
                        "show-overflow-tooltip": "",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "操作",
                        align: "center",
                        width: "100",
                        fixed: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editScheduleDay(
                                        [scope.row.goods_no],
                                        0
                                      )
                                    }
                                  }
                                },
                                [_vm._v("编辑天数")]
                              ),
                              _vm._v(" "),
                              scope.row.is_reminder == 1
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "margin-top": "5px",
                                        color: "red"
                                      },
                                      attrs: { type: "danger", size: "small" }
                                    },
                                    [
                                      _vm._v("\n                客服催单"),
                                      _c("br"),
                                      _vm._v(
                                        _vm._s(scope.row.gr_update_time) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.is_stop_sale == 0
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "margin-left": "0 !important"
                                      },
                                      attrs: { type: "danger", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addEmergency(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v("断货并"),
                                      _c("br"),
                                      _vm._v("加入急救箱")
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("preview-image", {
        attrs: { imgs: _vm.images, show: _vm.showbox },
        on: {
          closeBox: function($event) {
            return _vm.closeBox()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76d739e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76d739e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wcgplan/ScheduleList.vue
// module id = null
// module chunks = 